import React, { useState } from "react";
import { IconType } from "react-icons";
import { User, Key } from "react-feather";
import { Container, ErrorDiv, ErrorSpan, Input, InputDiv } from "./styles";
import theme from "../../Styles/theme";

interface Props {
  placeholder: string;
  type: "pass" | "cpf" | "nome" | "cnpj";
  execute: any;
  value: string;
  error?: string;
}
export function LoginInputs({ placeholder, type, execute, value }: Props) {
  const [focus, setFocus] = useState(false);

  function defineMaxLenght() {
    if (type == "cpf") {
      return 14;
    } else if (type == "cnpj") {
      return 18;
    } else return 150;
  }
  return (
    <Container>
      <InputDiv>
        {type == "cpf" || type == "cnpj" || type == "nome" ? (
          <User
            size={"calc(0.8vw + 0.6rem)"}
            color={focus ? theme.colors.primary : theme.colors.dark}
          />
        ) : (
          <Key
            size={"calc(0.8vw + 0.6rem)"}
            color={focus ? theme.colors.primary : theme.colors.dark}
          />
        )}
        <Input
          maxLength={defineMaxLenght()}
          placeholder={placeholder}
          focus={focus}
          onChange={(ev) => {
            execute(ev.target.value);
          }}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          type={type == "cpf" || type == "cnpj" || type =="nome" ? "text" : "password"}
          value={value}
        />
      </InputDiv>
    </Container>
  );
}
